export const baseURL = import.meta.env.VITE_API_BASE_URL;
export const posthogKey = import.meta.env.VITE_APP_PUBLIC_POSTHOG_KEY;
export const posthogHost = import.meta.env.VITE_APP_PUBLIC_POSTHOG_HOST;
export const CSVDownloadUrl = import.meta.env.VITE_CSV_DOWNLOAD_URL;
export const WBSCSVDownloadUrl = import.meta.env.VITE_WBS_CSV_DOWNLOAD_URL;
// export const WBSRISKCSVDownloadUrl = import.meta.env.VITE_WBS_RISK_CSV_DOWNLOAD_URL;
export const googleCredentialsClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const googleApiKey = import.meta.env.VITE_GOOGLE_API_KEY;
export const smartElementKey = import.meta.env.SMART_ELEMENT_KEY;
export const tawkPropertyid = import.meta.env.VITE_APP_PUBLIC_TAWK_PROPERTYID;
export const tawkWidgetid = import.meta.env.VITE_APP_PUBLIC_TAWK_WIDGETID;
export const stripeKey = import.meta.env.VITE_APP_STRIPE_KEY;
export const msalClientId = import.meta.env.VITE_MSAL_CLIENT_ID;
export const msalTenatId = import.meta.env.VITE_MSAL_TENANT_ID;
export const msalSecretId = import.meta.env.VITE_MSAL_SECRET_ID;
export const appUrl = import.meta.env.VITE_APP_URL;
export const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY
export const requestURLs = {
  rootAuth: `${baseURL}/api/auth/root-auth`,
  login: `${baseURL}/api/auth/login`,
  signup: `${baseURL}/api/auth/sign-up`,
  project: `${baseURL}/api/project`,
  projectWithoutCalulationQuery: `${baseURL}/api/project/project-no-calculation`,
  organisation: `${baseURL}/api/organisation`,
  updateOrganisationRiskSettings: `${baseURL}/api/organisation-risk-settings/`,
  updateOrganisationNonWorkingDays: `${baseURL}/api/organisation-nonworking-days/`,
  updateOrganisationKpiSettings: `${baseURL}/api/organisation-kpi-settings/`,
  userUpdateProfile: `${baseURL}/api/user/`,
  updateUserOrganisationSettings: `${baseURL}/api/user/organisation/`,
  me: `${baseURL}/api/user/me`,
  dismissTimesheetMgmtAnnouncement: `${baseURL}/api/user/me/dismiss-timesheet-mgmt-announcement`,
  verifyEmail: `${baseURL}/api/user/verify-email`,
  resendVerifyEmailOtp: `${baseURL}/api/user/resend-otp`,
  forgotPassword: `${baseURL}/api/auth/forgot-password`,
  resetPassword: `${baseURL}/api/auth/reset-password`,
  task: `${baseURL}/api/task/`,
  taskMember: `${baseURL}/api/task-members/`,
  fileUpload: `${baseURL}/api/user/avatarImg-update`,
  projectDocumentUpload: `${baseURL}/api/project/upload-document`,
  changePassword: `${baseURL}/api/user/change-password`,
  notification: `${baseURL}/api/notification/`,
  kanbanColumn: `${baseURL}/api/project/kanban-column/`,
  logOut: `${baseURL}/api/auth/logOut`,
  refreshToken: `${baseURL}/api/auth/access-token`,
  adminPortfolioDashboardData: `${baseURL}/api/dashboard/administartorProjects`,
  managerPortfolioDashboardData: `${baseURL}/api/dashboard/projectManagerProjects`,
  teamMemberPortfolioDashboardData: `${baseURL}/api/dashboard/teamMemberProjects`,
  projectStatusSummary: `${baseURL}/api/dashboard/projectStatusSummary`,
  portfolioProgressSummary: `${baseURL}/api/dashboard/portfolioProgressSummary`,
  projectPerformanceSummary: `${baseURL}/api/dashboard/projectPerformanceSummary`,
  portfolioCapacitySummary: `${baseURL}/api/dashboard/portfolioCapacitySummary`,
  projectDashboardData: `${baseURL}/api/dashboard/dashboardByProjectId`,
  projectSummary: `${baseURL}/api/dashboard/project-summary`,
  projectPerformance: `${baseURL}/api/dashboard/project-performance`,
  projectAlerts: `${baseURL}/api/project-alert`,
  projectHighlights: `${baseURL}/api/project-highlight`,
  multipleProjectsDashboardData: `${baseURL}/api/dashboard/multipleProjectsData`,
  ip: `${baseURL}/api/auth/my-ip`,
  paymentCheckout: `${baseURL}/api/payment/checkout-session`,
  paymentUpgradeToEnterprise: `${baseURL}/api/payment/upgrade`,
  paymentStatus: `${baseURL}/api/payment/check-status/`,
  paymentInvoice: `${baseURL}/api/payment/invoice/`,
  paymentInvoicePortal: `${baseURL}/api/payment/invoice-portal`,
  risk: `${baseURL}/api/risk/`,
  ribbon: `${baseURL}/api/ribbon`,
  setting: `${baseURL}/api/setting`,
  paymentSubscription: `${baseURL}/api/payment/subscription/`,
  createAppClient: `${baseURL}/api/v1/create-token/`,
  removeAppClient: `${baseURL}/api/v1/token/`,
  appClient: `${baseURL}/api/v1/tokens/`,
  wbsTask: `${baseURL}/api/wbs-task/`,
  wbsRisk: `${baseURL}/api/wbs-risk/`,
  collaboratorVerificationToken: `${baseURL}/api/auth/collaborator-token/`,
  availability: `${baseURL}/api/availability/`,
  absentType: `${baseURL}/api/availability/absent-type/`,
  capacityPlanning: `${baseURL}/api/project/capacity-planning`,
  capacityPlanningActuals: `${baseURL}/api/project/capacity-planning-actuals`,
  capacityPlanningActualsDrilldown: `${baseURL}/api/project/capacity-planning-actuals/drilldown`,
  taskNote: `${baseURL}/api/taskNote/`,
  timesheet: `${baseURL}/api/timesheet/`,
  timesheetDefaultRow: `${baseURL}/api/timesheet-default-row`,
  timesheetDefaultRowEnsureDefaults: `${baseURL}/api/timesheet-default-row/ensure-defaults`,
  updateTimesheet: (timesheetId: string) => `${baseURL}/api/timesheet/${timesheetId}/update`,
  resourceAdministrator: `${baseURL}/api/resource-administrator`,
  reference: `${baseURL}/api/reference`,
};
